import type { ReactNode } from 'react';
import { Icon } from '../icon/icon';
import * as icons from '../icon/assets';
import { cn } from '@workspace/ui/lib/utils';

interface BaseToastProps {
  icon?: keyof typeof icons;
  children: ReactNode;
  actionNode?: ReactNode;
  className?: string;
}

function BaseToast({ icon, children, actionNode, className }: BaseToastProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 p-4 rounded-[var(--radius-toast)] text-size-5 font-bold leading-font-height-5',
        className,
      )}
    >
      {icon && <Icon name={icon} size={24} color='var(--icon-icon-on-color)' />}
      <div className='text-text-on-color'>{children}</div>
      {actionNode && <div>{actionNode}</div>}
    </div>
  );
}

function Default({ children, actionNode }: BaseToastProps) {
  return (
    <BaseToast className='bg-surface-black' icon='ChevronLeft' actionNode={actionNode}>
      {children}
    </BaseToast>
  );
}

function Confirm({ children }: BaseToastProps) {
  return (
    <BaseToast icon='CircleCheckFilled' className='bg-action-green'>
      {children}
    </BaseToast>
  );
}

function Destructive({ children }: BaseToastProps) {
  return (
    <BaseToast icon='AlertTriangleFilled' className='bg-action-red-default'>
      {children}
    </BaseToast>
  );
}

const ToastItem = {
  Default,
  Confirm,
  Destructive,
};

export { ToastItem };
